
const LOCATION_COOKIE = 'ha-state-prst';
const SEARCH_COOKIE = 'ha-trip-prst';

const DEFAULT_LOCATION_DATA = {
  destination: '',
  lbsId: ''
};
const DEFAULT_SEARCH_DATA = {
  checkIn: null,
  checkOut: null,
  guests: {
    adultsCount: 0,
    childrenCount: 0,
    petIncluded: false
  }
};

const decodeCookieValue = (value, onError) => {
  let parsedCookie;

  try {
    parsedCookie = JSON.parse(decodeURIComponent(value));
  } catch (error) {
    if (typeof onError === 'function') {
      onError(error);
    }
    parsedCookie = null;
  }

  return parsedCookie;
};

const getKeyFromCookie = (cookie = '', key, onError) => {
  const match = cookie.match(new RegExp(`${key}=([^;]+)`));
  return match ? decodeCookieValue(match[1], onError) : null;
};

function getDatesFromCookie(cookie) {
  const { arrival, departure } = cookie;

  const arrivalMs = Date.parse(arrival);
  const departureMs = Date.parse(departure);

  const todayMs = Date.parse(new Date().toISOString().split('T')[0]);

  if (arrival && departure && arrivalMs >= todayMs && arrivalMs < departureMs) {
    return {
      checkIn: arrival,
      checkOut: departure
    };
  }

  return {
    checkIn: DEFAULT_SEARCH_DATA.checkIn,
    checkOut: DEFAULT_SEARCH_DATA.checkOut
  };
}

function isString(value) {
  return typeof value === 'string' || value instanceof String;
}

function getLocationDataFromCookies(cookie, onError) {
  const locationData = getKeyFromCookie(cookie, LOCATION_COOKIE, onError);

  if (!locationData) {
    return DEFAULT_LOCATION_DATA;
  }

  const { lbsKeywords, lbsId } = locationData;

  return {
    destination: isString(lbsKeywords) ? lbsKeywords.replace(/\+/g, ' ') : DEFAULT_LOCATION_DATA.destination,
    lbsId: lbsId || DEFAULT_LOCATION_DATA.lbsId
  };
}

function getSearchDataFromCookies(cookie, onError) {
  const searchData = getKeyFromCookie(cookie, SEARCH_COOKIE, onError);

  if (!searchData) {
    return DEFAULT_SEARCH_DATA;
  }

  const {
    numberOfAdults: adultsCount = 0,
    numberOfChildren: childrenCount = 0,
    petIncluded
  } = searchData;

  return {
    ...getDatesFromCookie(searchData),
    guests: {
      adultsCount: +adultsCount,
      childrenCount: +childrenCount,
      petIncluded: typeof petIncluded === 'string' ? petIncluded === 'true' : petIncluded
    }
  };
}

export {
  getLocationDataFromCookies,
  getSearchDataFromCookies,
  getKeyFromCookie
};
